import './App.css';
import ZakatCalculator from './components/ZakatCalculator';

function App() {
  return (
    <div className="App">
      <ZakatCalculator />
    </div>
  );
}

export default App;
